<template>
  <div class="footer">
    <div class="footer-content">
      <div class="left">
      <div class="contact">联系我们</div>
      <div class="line"></div>
      <div class="name">
        <img class="logo" src="../assets/homePage/logoWhite.png"/>
      </div>
      <div class="info">
        <div class="address">地址：沈阳市浑南区营盘北街3号409、410室</div>
        <div class="phone">电话：024 -22592535</div>
      </div>
      <div class="bottom-info">玖聚 © 辽宁玖聚律师事务所  辽ICP备2025064673号</div>
      </div>
      <img class="ercode" src="../assets/homePage/ercode.png" alt />
    </div>
  </div>
</template>

<script>
export default {
  name:'Footer',
  data() {
    return {
    };
  },
  methods: {
  }
};
</script>

<style lang="scss">
.footer {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  position: relative;
  background: url(../assets/homePage/home_img_lxwmbg.png) no-repeat center;
  background-size: cover; /* 确保背景图填满 */
  padding: 0 10vw;
  box-sizing: border-box;

  &-content {
    width: 100%;
    height: 100%;
    .left{
      position: absolute;
      bottom: 61px;
    }
    .contact {
      font-weight: 500;
      font-size: 56px;
      color: #FFFFFF;
      line-height: 66px;
      padding-top: 24px;
    }

    .line {
      margin-top: 11px;
      width: 62px;
      height: 2px;
      background: #fff;
    }

    .name {
      margin-top: 77px;
      font-weight: 500;
      font-size: 18px;
      color: #FFFFFF;
      line-height: 21px;
    }

    .info {
      padding-top: 41px;
      font-weight: 400;
      font-size: 16px;
      color: #fff;
      line-height: 30px;
    }

    .bottom-info {
      margin-top: 76px;
      font-weight: 400;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.5);
      line-height: 19px;
    }

    .ercode {
      position: absolute;
      bottom: 157px;
      right: 10vw;
      width: 200px;
      height: 200px;
      padding: 10px;
    }
  }
}
</style>
